//#region Enums

export enum EnumIdsTcTipoSolicitudEx {
    ID_TERCER_PAIS = 1,
    ID_REEXPORTACION = 2,
    ID_CANARIAS = 3,
    ID_ANULACION_SUSTITUCION = 4,
    ID_ATESTACION_FITOSANITARIA = 5,
    ID_CAMPANIAS_ESPECIFICAS = 6,
}

export enum EnumIdsTwTcSubTipoSolicitudEx {
    ID_TERCER_PAIS_CON_ATEST_FITO = 1,
    ID_TERCER_PAIS_SIN_ATEST_FITO = 2,
    ID_REEXPORTACION_CON_ATEST_FITO = 3,
    ID_REEXPORTACION_SIN_ATEST_FITO = 4,
    ID_CANARIAS_CON_ATEST_FITO = 5,
    ID_CANARIAS_SIN_ATEST_FITO = 6,
    ID_CAMPANIAS_CON_AVISO_CONF = 7,
    ID_CAMPANIAS_SIN_AVISO_CONF = 8,
}

export enum EnumLabelTipoSolicitud {
    ID_PREVIA = ' - Previa',
    ID_RE_IMPORTACION = ' - Re-Importación',
    ID_NORMAL = 'Normal',
    ID_PASAJEROS = 'Pasajeros',
    ID_CANARIAS = 'Canarias',
    ID_TRASLADO = 'Traslado',
    ID_FINES_CIENTIFICOS = 'Fines Científicos',
    ID_TRANSITO_DIRECTO = 'Tránsito Directo',
    ID_TRANSBORDO = 'Transbordo',
    ID_PRODUCTOS_FITOSANITARIOS = 'Productos Fitosanitarios',
}

export enum EnumLabelTipoSolicitudEx {
    ID_PREVIA = ' - Previa',
    ID_TERCER_PAIS = 'Tercer País',
    ID_RE_EXPORTACION = 'Re-Exportación',
    ID_CANARIAS = 'Canarias',
    ID_CAMPANIAS_ESPECIFICAS = 'Campañas Específicas',
}

export enum EnumLabelEstadoSolicitud {
    ID_BORRADOR = 'Borrador',
    ID_PENDIENTE = 'Pendiente',
    ID_AVISO_CONFECCION = 'Aviso de Confección',
}

export enum EnumIdsTcEstadoSolicitudEx {
    ID_BORRADOR = 1,
    ID_NUEVA = 2,
    ID_FINALIZADA_CONFORME = 3,
    ID_RECHAZADA_INSPECTOR = 4,
    ID_EN_TRAMITE = 5,
    ID_ANULADA = 6,
    ID_PREVIA_ACEPTADA = 7,
    ID_PREVIA_PENDIENTE = 8,
    ID_REVISION_SOLICITANTE = 9,
    ID_REVISADO_SOLICITANTE = 10,
    ID_AVISO_CONFECCION = 11,
}

export enum EnumIdsTwTcEstadoAvisoConfeccionEx {
    ID_PENDIENTE = 1,
    ID_PRESENTADO = 2,
    ID_ACEPTADO = 3,
    ID_RECHAZADO = 4,
}

export enum EnumIdsTcEstadoCertificadoFitoEx {
    ID_PENDIENTE = 1,
    ID_FINALIZADO_CONFORME = 2,
    ID_ANULADO = 3,
    ID_ANULADO_SUSTITUIDO = 4,
    ID_RECHAZADO_EPHYTO = 5,
    ID_ENVIADA_EPHYTO = 6,
    ID_ENVIADA_ANULACION_EPHYTO = 7,
    ID_ENVIADA_ANULACION_SUSTITUCION_EPHYTO = 8,
}

export enum EnumIdsTcFormatoSolicitud {
    ID_APLICACION = 1,
    ID_PAPEL = 2,
}

export enum EnumIdsTipoOperacionEnvioEphyto {
    SUBMIT = 'SUBMIT',
    TRACK = 'TRACK',
}

export enum EnumIdsTwTcResultadoEnvioMuestraLaboratorioEx {
    ID_PENDIENTE = 1,
    ID_ACEPTADA = 2,
    ID_RECHAZADA = 3,
}

export enum EnumTipoReasignacion {
    AUT = 'Automática',
    MAN = 'Manual',
    SIS = 'por el Sistema',
}

export enum EnumTipoReasignacionAbrev {
    AUTOMAT = 'A',
    MANUAL = 'M',
    SISTEMA = 'S',
}

export enum EnumModoReasignacion {
    Automatica = 'A',
    Manual = 'M',
    Inicial = 'B',
    Sistema = 'S',
}

export enum EnumModoReasignacionDesc {
    Automatica = 'Asignado Automáticamente',
    Manual = 'Asignado Manualmente',
    Inicial = 'Asignado Inicialmente',
    Sistema = 'Asignado por el Sistema',
}
